import { CommonGridToolBarWithFilterText } from '../../../Components/Common Components/CommonComponents';
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Checkbox, IconButton, TextField, CircularProgress, Box, Typography, Tooltip, FormControl, RadioGroup, Radio, FormControlLabel, Drawer, Stack, Button, Autocomplete } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Colors } from "../../../Styles/Colors";
import { ImagePaths } from "../../../Utility/ImagePaths";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { DateTime } from 'luxon';
import { AmountFormat, ContentInTooltip, formatDate, GetStoreBaseUrl } from '../../../Components/CommonFunctions/CommonFunctions';
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

const datelist = {
    fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
    dateIndex: 1,
    selectFromloc: null,
    selectToloc: null,
    selectCategory: null,
}

const StoreStockTransferReport = () => {
    const history = useHistory();
    const location = useLocation();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [stockValue, setstockValue] = useState([]);
    const [isloader, setisloader] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [filterData, setfilterData] = useState(datelist);
    const [SubLocationList, setSubLocationList] = useState([]);
    const [categoryList, setcategoryList] = useState([]);


    useEffect(() => {
        getStoreStockValue()
        getSubLocationList()
    }, [])

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getStoreStockValue = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_STOCK_TRANSFER_REPORT + `?from_date=${filterData.fromDate}&to_date=${filterData.toDate}&from_location=${filterData.selectFromloc?.id || ''}&to_location=${filterData.selectToloc?.id || ''}&category=${filterData.category?.id || ''}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setstockValue(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getSubLocationList = (storeObj = null) => {
        try {
            RestAPIService.getAll(Serviceurls.SUB_LOCATION_CREATION_MASTER + '?only_store=true')
                .then((response) => {
                    if (response.data.status === 'success') {
                        setSubLocationList(response.data.data || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getCategoryList = () => {
        try {
            RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setcategoryList(response.data.data || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const FilterDate = (from, to, index) => {
        setfilterData({ ...filterData, fromDate: from, toDate: to, dateIndex: index })
    }

    const renderFilterScreen = () => {
        return (
            <Box className='eMed_rts_filter_container' >
                <Box className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>Filter</Typography>
                    <Tooltip>
                        <Button onClick={() => { setFilterOpen(false) }}>
                            <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_Canteen_CloseImg' />
                        </Button>
                    </Tooltip>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={filterData.fromDate}
                            ToDate={filterData.toDate}
                            DateIndex={filterData.dateIndex}
                            SelectedDates={FilterDate.bind(this)} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            disableClearable
                            size='small'

                            value={filterData.selectFromloc}
                            options={SubLocationList}
                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.sublocation_name}
                            onChange={(event, newValue) => {
                                setfilterData({ ...filterData, selectFromloc: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Select From Sub Location'}
                                />
                            )} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            disableClearable
                            size='small'
                            value={filterData.selectToloc}
                            options={SubLocationList}
                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.sublocation_name}
                            onChange={(event, newValue) => {
                                setfilterData({ ...filterData, selectToloc: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Select To Sub Location'}
                                />
                            )} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            disableClearable
                            size='small'
                            value={filterData.selectCategory}
                            options={categoryList}
                            getOptionLabel={(option) => (typeof (option) === 'string') ? option : option?.category_name}
                            onChange={(event, newValue) => {
                                setfilterData({ ...filterData, selectCategory: newValue })
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Select Category'}
                                />
                            )} />
                    </Box>
                </Box>
                <Box>
                    <Stack spacing={2} direction="row" justifyContent={'center'}>
                        <Button size='small' variant='outlined' className='eMed_Canteen_BtnText' onClick={() => {
                            setfilterData({
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                selectFromloc: null,
                                selectToloc: null,
                                selectCategory: null,
                            })
                        }}>Clear</Button>
                        <Button size='small' variant='contained' className='eMed_Canteen_BtnText' onClick={() => {
                            getStoreStockValue()
                            setFilterOpen(false)
                        }}>Search</Button>
                    </Stack>
                </Box>
            </Box>
        )
    }


    const closeFilter = () => {
        setFilterOpen(false);
    }

    const GetPrint = (Data = null) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.STORE_STOCK_TRANSFER_REPORT + `?id=${Data?.id || ""}&export_type=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }


    const tableView = () => {
        try {
            const gridToolBar = () => {
                return (
                    <Box>
                        <CommonGridToolBarWithFilterText />
                    </Box>
                )
            }
            stockValue?.forEach((element, index) => element.sno = index + 1)
            const columns = [
                {
                    field: 'indent_number', headerName: 'Request No', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.indent_number || '-'}</Box>)

                },
                {
                    field: 'request_date', headerName: 'Request Date', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.transfer_date ? (formatDate(params?.row?.transfer_date?.split("T")[0])) : '-'}</Box>)

                },
                {
                    field: 'from_location', headerName: 'From Location', flex: 0.07,
                    renderCell: (params) => (params.row.from_location ? params.row.from_location?.length > 12 ?
                        <Tooltip placement="top" title={params.row.from_location}><Typography fontSize={'0.9vw'}>{params.row.from_location?.slice(0, 12) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.from_location || '-'}</Typography> : '-')
                },
                {
                    field: 'to_location', headerName: 'To Location', flex: 0.07,
                    renderCell: (params) => (params.row.to_location ? params.row.to_location?.length > 12 ?
                        <Tooltip placement="top" title={params.row.to_location}><Typography fontSize={'0.9vw'}>{params.row.to_location?.slice(0, 12) + '...'}</Typography></Tooltip> :
                        <Typography fontSize={'0.9vw'}>{params.row.to_location || '-'}</Typography> : '-')
                },
                {
                    field: 'no_of_products', headerName: 'No of Product', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.no_of_products || '-'}</Box>)

                },
                {
                    field: 'transit_person_name', headerName: 'Transit Details', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{
                        <Box>
                            {params?.row?.transit_person_name ? ContentInTooltip(params?.row?.transit_person_name, 30, "0.8vw", 600) : "-"}
                            {params?.row?.transit_person_contact ? ContentInTooltip(params?.row?.transit_person_contact, 30, "0.8vw") : "-"}
                            {params?.row?.transit_tracking_id ? ContentInTooltip(params?.row?.transit_tracking_id, 30, "0.8vw") : "-"}
                        </Box>
                    }</Box>)

                },
                {
                    field: 'total_amount', headerName: 'Total Amt', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{AmountFormat(params?.row?.total_amount || 0)}</Box>)
                },
                {
                    field: 'approved_by', headerName: 'Approved By', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>{params?.row?.approved_by || '-'}</Box>)
                },
                {
                    field: 'action', headerName: 'Actions', flex: 0.07,
                    renderCell: (params) => (<Box component={'div'}>
                        <IconButton emed_tid={'Store_PI_grnEntry'} className='eMed_usrconf_btn' onClick={() => {
                            history.push({ pathname: `${GetStoreBaseUrl()}/IndentRise/Add`, states: { line_items: params?.row?.line_details, indent_data: params?.row, for_view_only: true, return_path: `${GetStoreBaseUrl()}/StockTranferReport`, return_screen: "Stock Transfer Report" } })
                        }}>
                            <img src={ImagePaths.StoreViewButton.default} alt="View" style={{ width: '1.5vw', height: '1.5vw' }} />
                        </IconButton>
                        <Tooltip title={"Print"} placement="top" arrow>
                            <Button
                                onClick={() => { GetPrint(params.row) }}
                                className='eMed_usrconf_btn' emed_tid='PO_requestList_print'>
                                <img src={ImagePaths.PrintIcons.default} alt="print" style={{ width: '1.5vw', height: '1.5vw' }} />
                            </Button>
                        </Tooltip>
                    </Box>)
                },
            ];
            return (
                <Box sx={{ height: '67vh', marginTop: '.5vw', backgroundColor: 'white' }}>
                    <DataGrid
                        rows={stockValue}
                        columns={columns}
                        getRowId={(row) => row['sno']}
                        page={page}
                        pageSize={pageSize}
                        localeText={{
                            toolbarColumns: "",
                            toolbarDensity: "",
                            toolbarExport: "",
                            toolbarFilters: "",
                            toolbarExportPrint: ""
                        }}
                        components={{
                            Toolbar: gridToolBar,
                            NoRowsOverlay: () => (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                    {'No Records To Be Shown'}
                                </Box>
                            )
                        }}
                        onPageChange={(newPage) => { setpage(newPage) }}
                        onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        headerHeight={40}
                        density='standard'
                        disableSelectionOnClick
                        loading={isloader}
                    />
                </Box>
            )
        } catch (e) {

        }
    }

    const msgClose = () => {
        seterrorMsg(false)
        seterrorMsgText("")
        setsuccessMsg(false)
        setsuccessMsgText("")
    }

    return (
        <Box sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box display={'flex'} justifyContent={'space-between'} flexDirection={'row'} alignItems={'center'}>
                <Box display={'flex'} flexDirection={'row'} marginLeft={'-.8vw'}>
                </Box>
                <Box>
                    <IconButton onClick={() => { setFilterOpen(true) }}>
                        <img style={{ width: '2vw', height: '2vw' }} src={ImagePaths.Filter.default} alt='filter' />
                    </IconButton>
                </Box>
            </Box>
            <Box>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
        </Box>
    );
}

export default StoreStockTransferReport